import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const UploadIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.14286 14.5744H12.8571V7.84775H18L9 0L0 7.84775H5.14286V14.5744ZM0 16.8167H18V19.0589H0V16.8167Z"
      fill="#97A3B4"
    />
  </svg>

);

UploadIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

UploadIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(18, 20),
};

export default UploadIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/upload.js